import { Component, Host, h, Prop, Watch, State, Event, type EventEmitter } from '@stencil/core';

@Component({
  tag: 'result-button',
  styleUrl: 'result-button.scss',
  shadow: true,
})
export class ResultButton {
  @Prop({ attribute: 'label' }) readonly label: string;
  @Prop({ attribute: 'result-counter' }) readonly resultCounterProp: string;
  @Prop({ attribute: 'selected-filters-exist'}) readonly selectedFiltersExistProp: Boolean;

  @State() resultCounter: number;
  @State() isButtonDisabled = true;

  @Event({
    eventName: 'click:button',
    bubbles: false
  }) clickButton: EventEmitter<void>;

  @Watch('resultCounterProp')
  onResultCounterChange(newValue: string) {
      this.resultCounter = parseInt(newValue);
  }

  @Watch('selectedFiltersExistProp')
  async onSelectedFiltersExistChange(newValue: boolean) {
      this.isButtonDisabled = newValue;
  }

  componentWillLoad(): void {
      this.resultCounter = parseInt(this.resultCounterProp);
  }

  render() {
      return (
        <Host>
          <button
            class={'result-button'}
            disabled={this.isButtonDisabled}
            onClick={() => this.clickButton.emit()}
          >{this.label}{this.resultCounter ? ` (${this.resultCounter})` : ''}</button>
        </Host>
      );
  }
}
